import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { QuoteConfirmationPageInitialData } from "./quoteConfirmationPageInitialData";

export const quoteConfirmationPageQueryOptions = (orderCode: string) =>
  queryOptions({
    queryKey: pageDataKeys.page(`quote/confirm/${orderCode}`),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<QuoteConfirmationPageInitialData>>(
        `/page-data/quote/confirm/${orderCode}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
